module.exports = __webpack_public_path__ + "static/media/soccer_open.35a722fb.jpg";